
import axios from "axios"
import ApiStore from "./ApiStore";
// var querystring = require('querystring');

export class ServicePlanStore extends ApiStore{
  constructor() {
    super();

  }

  loadSchedule(sId,completeFunc){
    axios.get('serviceplan/schedule/'+sId)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  saveSchedule(catId,data,completeFunc,errorFunc){
    axios.post('serviceplan/schedule/'+catId,data)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }
}  

export default new ServicePlanStore()


// WEBPACK FOOTER //
// ./src/stores/ServicePlanStore.js